import { useState } from 'react';

import { css } from '@emotion/css';
import { Button, TextField } from '@mui/material';
import { Notification, useLogin, useNotify } from 'react-admin';
import { ColorConstant } from 'src/styles';

import Logo from '../../assets/Logo.svg';

import { mainDiv, childDiv } from './Styles';

const loginButtonStyle = css`
  margin-top: 15px !important;
  min-width: 250px !important;
  background-color: ${ColorConstant.BRAND6} !important;
  color: ${ColorConstant.GRAY1} !important;
  &:hover {
    background-color: ${ColorConstant.BRAND6} !important;
  }
`;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const login = useLogin();
  const notify = useNotify();

  const onSubmit = () => {
    login({ email, password }).catch(() => notify('Invalid email or password', { type: 'error' }));
  };

  return (
    <div className={mainDiv}>
      <div className={childDiv}>
        <img src={Logo} alt='Logo' />
        <br />
        <form>
          <TextField
            id='outlined-basic'
            label='Email'
            variant='outlined'
            defaultValue={email}
            onChange={(event: any) => setEmail(event.target.value)}
            style={{ marginTop: 15, minWidth: 250 }}
          />
          <br />
          <TextField
            type={'password'}
            id='outlined-basic-password'
            label='Password'
            variant='outlined'
            defaultValue={password}
            onChange={(event: any) => setPassword(event.target.value)}
            style={{ marginTop: 15, minWidth: 250 }}
          />
          <br />
          <Button variant='outlined' onClick={onSubmit} className={loginButtonStyle}>
            Log In
          </Button>
          <Notification />
        </form>
      </div>
    </div>
  );
};

export default Login;
